import { IGetState } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { setHintCanShow } from '../../../../../../hints/effects/setHintCanShow';
import { EHintKey } from '../../../../../../hints';
import { getActiveBoard } from '../../../../../../../../store/model/selectors/getActiveBoard';

export const onHintShow = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const activeBoard = getActiveBoard(getState());
        if (activeBoard) dispatch(setHintCanShow(EHintKey.NAVIGATION_PANEL_STARRED));
    };
    return action;
};
